module.exports = __webpack_public_path__ + "img/Greengrass.daee5a6d.png";